import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'hd-log',
  templateUrl: './hd-log.component.html',
  styleUrls: ['./hd-log.component.less']
})
export class HdLogComponent implements OnInit {
  @Input() logs: any[];

  constructor() {
  }

  ngOnInit() {
  }
}
